import type { CSSProperties } from "react";
import { C } from "../theme";

interface ProgressBarProps {
  /** Valor percentual 0-100. */
  value: number;
  height?: number;
  color?: string;
  style?: CSSProperties;
}

/** Barra de progresso (trilho faint, preenchimento lime por padrão). */
export function ProgressBar({ value, height = 8, color, style }: ProgressBarProps) {
  const pct = Math.min(Math.max(value, 0), 100);
  return (
    <div style={{ flex: 1, height, background: C.faint, borderRadius: 4, ...style }}>
      <div style={{ width: `${pct}%`, height, borderRadius: 4, background: color ?? C.lime }} />
    </div>
  );
}
